import moment from 'moment'

function getCurrentTimestamp() {
  return moment.utc().valueOf()
}

export default getCurrentTimestamp